import { makePostRequest } from './RequestHelpers';

const OPTIMIZELY_BASE = '/experimentation/api/public/v1';

export const isFeatureEnabled = (featureKey: string): Promise<boolean> =>
    makePostRequest(`${OPTIMIZELY_BASE}/enabled-feature/${featureKey}`, {});



// WEBPACK FOOTER //
// ./src/services/OptimizelyService.ts